import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../state'

import * as catalog from './catalog'
import * as configurator from './configurator'
import * as detail from './detail'
import * as stores from './stores'
import * as tools from './tools'

/**
 * Page in Summit used to edit your notes
 */
@ngCore.Component({
  imports: [
    catalog.Component,
    configurator.Component,
    detail.Component,
    ds.layout.page.Component,
    ds.layout.page.child.header.Component,
    ds.overlay.confirmation.Component,
    tools.Component,
  ],
  providers: [stores.Layout, stores.AiAssistantOrchestrator],
  selector: 'atn-summit-archive-page',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.summit.archive.Collection}  */
  public readonly archiveEc = ngCore.inject(state.summit.archive.Collection)
  /**
   * The archive item currently in the deletion process, if any
   *
   * Reflects the state that determines delete confirmation overlay visibility
   * and content
   */
  public archiveToBeDeletedSg = ngCore.computed(
    (
      [deletedArchive] = this.archiveEc.plugins.editingPlugin.feature.selectors
        .deletedEntities()
        .asSignal(),
    ) => deletedArchive,
  )
}
